import React , {useRef} from "react";
// import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TimeSlotSelection = ({
  // settings,
  uniqueMarkedDays,
  selectedDay,
  handleDayChange,
  filteredSlots,
  selectedSlot,
  handleSlotClick,
  // bookedSlots,
}) => {
  const { t } = useTranslation(); 

  const hasAvailableDays = uniqueMarkedDays.length > 0;

  const scrollContainerRef = useRef(null);

  // Scroll Functionality
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };


  return (
    <div className="sched-time-slot-select">
      <h3 className="sched-h3">{t("patient_view_timeslot.available_time_slots")}</h3>

      {!hasAvailableDays ? (
        <div className="no-slots-banner">
          <p>{t("patient_view_timeslot.no_available_slots")}</p>
        </div>
      ) : (
        <>
          <div className="schedule-hint">
            <p>{t("patient_view_timeslot.select_date_to_view")}</p>
          </div>
      
          <div className="sched-day-scroll-container" style={styles.scrollContainer}>
          {/* Left Scroll Button */}
          {uniqueMarkedDays.length > 3 && (
            <button style={{ ...styles.scrollButton, left: 0 }} onClick={scrollLeft}>
              ◀
            </button>
          )}

          {/* Scrollable Slot List */}
          <div className="sched-day-list" ref={scrollContainerRef} style={styles.slotList}>
            {uniqueMarkedDays.map((day, index) => (
              <button
                key={index}
                className={`sched-day-button ${
                  day === selectedDay ? "selected" : ""
                }`}
                onClick={() => handleDayChange(day)}
              >
                {moment(day).format("ddd, MMM D")}
              </button>
            ))}
          </div>

          {/* Right Scroll Button */}
          {uniqueMarkedDays.length > 3 && (
            <button style={{ ...styles.scrollButton, right: 0 }} onClick={scrollRight}>
              ▶
            </button>
          )}
          </div>
    
          <ul className="sched-ul">
            {filteredSlots.map((slot, idx) => (
              <li
                key={idx}
                className={`sched-slot-item ${
                  slot.isPast ? "sched-past-time" : ""
                } ${
                  selectedSlot &&
                  selectedSlot.start === slot.start &&
                  selectedSlot.end === slot.end
                    ? "selected-slot"
                    : ""
                }`}
                onClick={() => !slot.isPast && handleSlotClick(slot)}
                title={
                  slot.isPast
                    ? t("patient_view_timeslot.slot_in_past")
                    : `${t("patient_view_timeslot.click_to_select")}: ${moment(slot.start).format("HH:mm")} - ${moment(slot.end).format("HH:mm")}`
                }
              >
                {`${moment(slot.start).format("HH:mm")} - ${moment(
                  slot.end
                ).format("HH:mm")}`}
              </li>
            ))}
          </ul>

        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden", 
  },
  scrollContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    padding: "10px 40px", 
  },
  scrollButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
    padding: "10px",
    transition: "opacity 0.2s",
    zIndex: 2, 
  },
  slotList: {
    display: "flex",
    overflowX: "auto",
    whiteSpace: "nowrap",
    scrollBehavior: "smooth",
    maxWidth: "600px", 
    padding: "10px 0",
    gap: "10px", 
  },
};


export default TimeSlotSelection;
